import { Option } from '../../../../libs/types';

export const getInitialSelectedItems = (value: string[], options: Option[]): Option[] =>
  value.map(val => options.find(option => option.value === val)).filter((val): val is Option => !!val);
